<template>
    <div>
        <!--<div @click="searchPanel=true"-->
        <!--style="height:35px;width: 100%;position: fixed; top: 0px;text-align: center;background: #eee ;border-radius: 0 0 8px 8px">-->
        <!--<div style="margin-top:8px;">-->
        <!--<Icon name="search" size="16px" style="vertical-align:text-bottom;"/>-->
        <!--<span style="font-size:13px;">根据条件查询</span>-->
        <!--</div>-->
        <!--</div>-->
        <Popup v-model="searchPanel" position="top" style="height:240px;">
            <Field
                    v-model="fieldName"
                    label="查询通道"
                    right-icon="arrow-down"
                    placeholder="全部通道"
                    readonly
                    @click="showFieldPanel(true)"
            ></Field>
            <Field v-model="form.count" label="查询数量" type="number"></Field>
            <Field
                    v-model="form.startTime"
                    label="开始时间"
                    readonly
                    placeholder="请选择开始时间"
                    right-icon="arrow-down"
                    @click="showStartTimePanel(true)"
            ></Field>
            <Field
                    v-model="form.endTime"
                    label="结束时间"
                    readonly
                    placeholder="请选择结束时间"
                    right-icon="arrow-down"
                    @click="showEndTimePanel(true)"
            ></Field>
            <Button block type="info" class="button" @click="getDeviceStateSequence">
                <Icon name="search" size="20px" style="vertical-align:text-bottom;"/>
                查询
            </Button>
        </Popup>
        <SelectFieldPopup
                :list="fieldList"
                :show="fieldPanel"
                @cancel="showFieldPanel(false)"
                @ok="changeFieldList"
        />
        <DateTimePopup
                type="start"
                :max="form.endTime"
                :time="form.startTime"
                :timePanel="startTimePanel"
                @cancel="showStartTimePanel(false)"
                @ok="changeStartTime"
        />
        <DateTimePopup
                type="end"
                :min="form.startTime"
                :time="form.endTime"
                :timePanel="endTimePanel"
                @cancel="showEndTimePanel(false)"
                @ok="changeEndTime"
        />
        <div class="list">
            <div v-for="(item,index) in chartDataList" :key="index">
                <BigDataArea
                        :key="index"
                        :xData="item.xData"
                        :yData="item.yData"
                        :title="item.title"
                        :tooltipName="item.toolTipName"
                />
            </div>
        </div>
        <Icon name="search" size="30px" color="#fff" @click="searchPanel=true"
              class="float-btn-search"/>
    </div>
</template>

<script>
    import {Button, Field, Icon, Popup, Search} from "vant";
    import BigDataArea from "@/components/echarts/BigDataArea";
    import SelectFieldPopup from "@/components/SelectPopup/SelectFieldPopup"
    import DateTimePopup from "../components/DateTimePopup";
    import {dateFormat} from "@/utils/tool";

    export default {
        components: {Search, Icon, Popup, Field, Button, SelectFieldPopup, DateTimePopup, BigDataArea},
        props: {},
        data() {
            return {
                fieldList: [],
                deviceId: this.$route.params.id,
                searchPanel: false,
                fieldName: null,
                form: {
                    deviceId: this.$route.params.id,
                    fieldList: "",
                    count: 100,
                    startTime: "",
                    endTime: ""
                },
                fieldPanel: false,
                startTimePanel: false,
                endTimePanel: false,
                sequenceList: {},
                chartNameMap: {},
                chartUnitMap: {},
                chartDataList: []
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            this.initDate();
            this.getDeviceFieldList();
            this.getDeviceStateSequence();
        },
        methods: {
            showFieldPanel(show) {
                this.fieldPanel = show;
            },
            changeFieldList(codeList, nameList) {
                this.form.fieldList = codeList;
                this.fieldName = nameList;
                this.fieldPanel = false;
            },
            showStartTimePanel(show) {
                this.startTimePanel = show;
            },
            changeStartTime(value) {
                this.form.startTime = value;
                this.startTimePanel = false;
            },
            showEndTimePanel(show) {
                this.endTimePanel = show;
            },
            changeEndTime(value) {
                this.form.endTime = value;
                this.endTimePanel = false;
            },
            initDate() {
                const endTime = new Date();
                const startTime = new Date(endTime.getTime() - 1000 * 60 * 60 * 24 * 7);
                this.form.startTime = dateFormat("YYYY-MM-DD HH:mm:ss", startTime);
                this.form.endTime = dateFormat("YYYY-MM-DD HH:mm:ss", endTime);
            },
            getDeviceFieldList() {
                this.$http.tokiot.device.state.fieldList({deviceId: this.deviceId})
                    .then(res => {
                        if (res) {
                            this.fieldList = res;
                        }
                    });
            },
            getDeviceStateSequence() {
                this.searchPanel = false;
                this.$http.tokiot.device.state.timeSequence(this.form)
                    .then(ret => {
                        this.sequenceList = ret
                    })

            }
        },
        watch: {
            sequenceList(sequenceList) {
                console.info('watch-sequenceList', sequenceList)
                // chartNameMap, chartUnitMap  已经被通道列表的监听事件生成，可以直接拿过来用
                const {chartNameMap, chartUnitMap} = this
                // 解决排序问题，遍历已经排序好的通道列表，生成通道的配置信息
                const chartDataList = []
                this.fieldList.map(item => {
                    const key = item.code
                    const sequence = sequenceList[key]
                    if (sequence && sequence.reverse()) {
                        chartDataList.push({
                            code: key, title: chartNameMap[key],
                            xData: sequence.map(item => item.time),
                            yData: sequence.map(item => item.value),
                            toolTipName: chartNameMap[key] + chartUnitMap[key],
                        })
                    }
                })
                this.chartDataList = chartDataList;
            },
            fieldList(fieldList) {
                // 这里只会执行一次，为了解决因图表信息早于通道列表的问题，这里会同时触发图表信息的监听事件
                const chartNameMap = {};
                const chartUnitMap = {};
                fieldList.forEach(item => {
                    chartNameMap[item.code] = item.name;
                    if (item.valueRange && item.valueRange.unit) {
                        chartUnitMap[item.code] = '(' + item.valueRange.unit + ')';
                    } else {
                        chartUnitMap[item.code] = '';
                    }
                });
                this.chartNameMap = chartNameMap;
                this.chartUnitMap = chartUnitMap;

                // 触发watch
                const list = this.sequenceList
                this.sequenceList = list
            }
        }
    }
</script>

<style lang="less" scoped>

    .float-btn-search {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 50px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }

    .button {
        margin: 5px auto;
        width: 95%;
    }

    .list {
        margin-top: 20px;
        overflow-y: scroll;
    }
</style>